<template>
  <v-app :dark="isDark" :class="{ 'dark-mode': isDark }">
    <v-container>
      <div class="ma-4">
        <v-row>
          <v-col>
            <div class="text-center subtitle-1 grey--text">Доступно {{ availableDays }} дня</div>
          </v-col>
        </v-row>
      </div>

      <!-- Date range selector -->
      <v-card :dark="isDark" :class="{ 'dark-mode': isDark }" class="mb-4 pa-4 rounded-lg" outlined>
        <div class="subtitle-1 grey--text mb-2">Выберите на какие дни хотите</div>
        <v-menu
          ref="dateMenu"
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
              append-icon="mdi-calendar"
              class="rounded-lg"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateRange"
              range
              :min="minDate"
              :max="maxDate"
              @input="onDateInput"
              elevation="0"
              :dark="isDark"
              class="datePicker"
          />
        </v-menu>
        <div v-if="dateRangeError" class="error--text mt-1 caption">
          {{ dateRangeError }}
        </div>
      </v-card>

      <!-- Reason selector -->
      <v-card class="mb-4 pa-4 rounded-lg" outlined :dark="isDark" :class="{ 'dark-mode': isDark }">
        <div class="subtitle-1 grey--text mb-2">Выберите причину</div>
        <v-menu
          ref="reasonMenu"
          v-model="reasonMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="reason"
              outlined
              dense
              v-bind="attrs"
              v-on="on"
              :dark="isDark"
              append-icon="mdi-chevron-right"
              class="rounded-lg"
            ></v-text-field>
          </template>
          <v-list class="datePicker">
            <v-list-item
              v-for="(item, index) in reasonOptions"
              :key="index"
              :dark="isDark"
              @click="selectReason(item)"
            >
              <v-list-item-title class="datePicker">{{ item }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card>

      <!-- Description -->
      <v-card class="mb-4 pa-4 rounded-lg" outlined :dark="isDark" :class="{ 'dark-mode': isDark }">
        <div class="subtitle-1 grey--text mb-2">Опишите</div>
        <v-textarea
          v-model="description"
          outlined
          auto-grow
          rows="3"
          :dark="isDark"
          class="rounded-lg"
          hide-details
        ></v-textarea>
      </v-card>

      <!-- Submit button -->
      <v-card :dark="isDark" :class="{ 'dark-mode': isDark }">
        <v-card-actions class="pa-0">
          <v-btn
            color="#1751D0"
            large
            style="width: 100%"
            class="white--text rounded-lg ma-0 pa-0"
            @click="submitRequest"
            :disabled="!dateRange.length || !reason"
          >
            Отправить заявку
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import {backArrow, isWebViewBridgeAvailable, setTabActiveHandler, setTitle, storage} from '@orta/bridge';

export default {
  data() {
    return {
      theme: 'light',
      dateMenu: false,
      reasonMenu: false,
      dateRange: [],
      reason: '',
      description: '',
      availableDays: 28,
      maxDaysAllowed: 28,
      dateRangeError: '',
      minDate: new Date().toISOString().substr(0, 10),
      maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().substr(0, 10),
      tempDate: null,
      reasonOptions: [
        'Ежегодный отпуск',
        'Отпуск без сохранения заработной платы',
        'Отпуск по болезни',
        'Семейные обстоятельства',
        'Личные дела'
      ],
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'VacationView', replace: true });
    },
    tabActiveHandler(){
      this.$router.replace({
        name: 'HomeView'
      })
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    },
    validateDateRange() {
      this.dateRangeError = '';

      if (this.dateRange.length === 2) {
        const [start, end] = this.dateRange;
        const diffTime = Math.abs(new Date(end) - new Date(start));
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

        if (diffDays > this.maxDaysAllowed) {
          this.dateRangeError = `Максимальное количество дней: ${this.maxDaysAllowed}`;
          const maxEnd = new Date(start);
          maxEnd.setDate(new Date(start).getDate() + this.maxDaysAllowed - 1);
          this.dateRange = [start, maxEnd.toISOString().substr(0, 10)];
        }
      }
    },
    onDateInput(date) {
      // When first date is selected, store it temporarily
      if (!this.tempDate && date) {
        this.tempDate = date;
        return;
      }

      // When second date is selected, create the range
      if (this.tempDate && date) {
        const [first, second] = [this.tempDate, date].sort();
        this.dateRange = [first, second];
        this.tempDate = null;
        this.validateDateRange();
        this.dateMenu = false;
      }
    },
    selectReason(item) {
      this.reason = item;
      this.reasonMenu = false;
    },

    async submitRequest() {
      if (!this.dateRange.length || !this.reason) {
        // Show error or validation message
        return;
      }

      // Validate date range one more time before submitting
      this.validateDateRange();
      if (this.dateRangeError) {
        return;
      }

      const vacationRequest = {
        id: Date.now(),
        dateRange: this.dateRange,
        reason: this.reason,
        description: this.description,
        status: 'pending',
        createdAt: new Date().toISOString()
      };

      try {
        // Get existing vacations
        let existingRequests = [];
        let storedRequests;
        try {
          storedRequests = await storage.getItem('vacations');
        } catch (e) {
          console.error(e);
        }

        if (storedRequests) {
          existingRequests = JSON.parse(storedRequests);
        }

        // Add new request
        existingRequests.push(vacationRequest);

        // Store updated vacations
        await storage.setItem('vacations', JSON.stringify(existingRequests));

        // Navigate back to vacation view
        await this.$router.push({name: 'Success', replace: true});
      } catch (error) {
        console.error('Error saving vacation request:', error);
      }
    }
  },
  mounted() {
    if (isWebViewBridgeAvailable()) {
      // onNativeEvent(({event}) => event === 'tappedNavigationBarBackButton' && this.$router.push({ name: 'TestRouter', replace: true }));
      setTitle('Запрос отпуска')
      setTabActiveHandler(this.tabActiveHandler.bind(this))
      backArrow.setVisible(true);
      backArrow.setMode(true);
      backArrow.setOnClickHandler(this.goBack.bind(this));
    }
  },
  computed: {
    isDark() {
      return this.theme === 'dark';
    },
    dateRangeText() {
      if (!this.dateRange || this.dateRange.length === 0) return '';

      if (this.dateRange.length === 1) {
        return this.formatDate(this.dateRange[0]);
      }

      if (this.dateRange.length === 2) {
        const startDate = new Date(this.dateRange[0]);
        const endDate = new Date(this.dateRange[1]);
        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // Include both start and end days

        return `${this.formatDate(this.dateRange[0])} - ${this.formatDate(this.dateRange[1])} (${diffDays} дн.)`;
      }

      return '';
    },
  },
  created() {
    this.theme = this.$route.query.theme || localStorage.getItem('theme') || 'light';
  }
}
</script>

<style scoped>
.datePicker {
  background-color: var(--bg-color-secondary);
  color: var(--text-color);
}

</style>
